import React, { useEffect, useState } from 'react';
import '../TextInput/style/TextInput.css';

import warning_icon from '../../../assets/icons/WarningCircle.svg';
import { t } from 'i18next';

const TextInputV = ({
    isRequired,
    value,
    onInputChange,
    isSubmitted,
    errorText,
    labelText,
    multiline = false,
    maxLength = Infinity,
    rows,
    placeholder,
    type = 'text',
    storageKey,
}) => {
    const [error, setError] = useState(false);

    useEffect(() => {
        if (isSubmitted && isRequired && (!value || value.trim() === '')) {
            setError(true);
        } else {
            setError(false);
        }
    }, [isSubmitted, value, isRequired]);

    const handleInputChange = (e) => {
        const newValue = e.target.value;

        if (maxLength !== Infinity && newValue.length > maxLength) return;

        if (storageKey) {
            localStorage.setItem(storageKey, newValue);
        }

        onInputChange(newValue);
    };

    return (
        <div className="text_input_container">
            <div className="input_header">
                <label className="text_input_label">{labelText}</label>
                {maxLength !== Infinity && (
                    <span className="char_count">
                        {t('charactersLeft')} {maxLength - (value?.length || 0)}
                    </span>
                )}
            </div>

            {(isSubmitted && error) && (
                <div className="input_header error_row">
                    <span className="error_text">{errorText}</span>
                    <img src={warning_icon} alt="warning" />
                </div>
            )}

            <div className={`text_input_box ${error ? 'input_error' : ''}`}>
                {multiline ? (
                    <textarea
                        placeholder={placeholder}
                        value={value}
                        onChange={handleInputChange}
                        className="phone_input"
                        rows={rows}
                    />
                ) : (
                    <input
                        type={type}
                        placeholder={placeholder}
                        value={value}
                        onChange={handleInputChange}
                        className="phone_input"
                    />
                )}
            </div>
        </div>
    );
};

export default TextInputV;